import {Brick, ErrorFlow, registerBrick, Transaction} from 'olympe';
import {getTerminatedRequests} from '../../web/section_risk/RiskCrisis';
import BCP from './DM_BCP';

export default class DeleteBCPRequestIfTerminated extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} materialData
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [materialData], [forwardEvent, setErrorFlow]) {
        const materialId = materialData.materialId;
        const plantId = materialData.plantId;
        try {
            const finishedBCP = (await getTerminatedRequests([materialData], $))?.[0];
            if (finishedBCP?.get(BCP.materialIdProp) === materialId && finishedBCP?.get(BCP.plantIdProp) === plantId) {
                const t = new Transaction();
                t.delete(finishedBCP);
                await t.execute();
            }
        } catch (e) {
            setErrorFlow(ErrorFlow.create(`Failed to get terminated request or delete existing requests, with message: ${e.message}`, e.code));
        }
        // Trigger the output Control Flow
        forwardEvent();
    }
}

registerBrick('018b1dc22de944ab2955', DeleteBCPRequestIfTerminated);
